import React from "react";
import { Header, Footer, Reservation } from "../component";


const ReservationPage = () => {
  return (
    <>
      <Header/>
      <Reservation/>
      <Footer />
    </>
  );
};

export default ReservationPage;
